import {CircularProgress} from "@mui/material";

const SmallSpinner = () => {
  return (
      <CircularProgress color="inherit" sx={{alignSelf: "center"}} size={25}/>
  )
}

export default SmallSpinner;